import React, { Component } from 'react'
import { Modal, Input, TimePicker, Space, message } from 'antd'
import moment from 'moment'
import { addShift } from '../../api/employee'
import './index.css'

const RangePicker = TimePicker.RangePicker

export default class index extends Component {
  state = {
    name: '', //班次名称
    times: [], //班次时间
    visible: false, //弹窗
    shiftId: -1,
    action: '1', //-1,1
  }
  //获取input的内容
  onInputChange = (e) => {
    this.setState({ name: e.target.value || '' })
  }

  handleOk = async () => {
    const { name, times, action } = this.state
    let shiftData = {
      name,
      startTime: times[0],
      endTime: times[1],
      shiftId: this.state.shiftId ? this.state.shiftId : -1,
    }
    if (name == '') {
      message.error('请输入班次名称')
    } else if (times == '') {
      message.error('请输入时间')
    } else {
      const { status, detail } = await addShift(shiftData)
      if (status != 1) {
        message.error(detail)
        // message.success(`${action == '1' ? '修改' : '添加'}成功`)
      }
      this.setState({ visible: false, isLoading: false })
      this.props.onRefreshView()
      this.props.onCloseEvent()
    }
  }

  //关闭弹窗
  handleCancel = () => {
    this.props.onCloseEvent()
  }

  //获取上下班时间
  handleChangeTime = (time, timeString) => {
    this.setState({
      times: timeString,
    })
  }

  render() {
    const { visible, isEdit } = this.props
    const { name, times } = this.state
    return (
      <Modal
        title={!isEdit ? '新增班次' : '编辑班次'}
        visible={visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        width="500px"
      >
        <div className="shift-container">
          <div className="shift-content-view">
            <span>名称:</span>
            <Input
              size="middle"
              style={{ width: '50%', marginLeft: '1rem' }}
              defaultValue={name}
              placeholder="请输入名称"
              onChange={(value) => this.onInputChange(value)}
            />
          </div>
          <div className="shift-content-view">
            <span>时间:</span>
            <Space direction="vertical" style={{ width: '52%' }}>
              <RangePicker
                format="HH:mm"
                defaultValue={times}
                onChange={this.handleChangeTime}
                status="warning"
                style={{ width: '95%', marginLeft: '1rem' }}
              />
            </Space>
          </div>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shiftView/index.js